module.exports = __webpack_public_path__ + "static/media/walking-fries.5e321d44.svg";